<template>
  <div class="relative z-200">
    <Overlay :visible="isWaitlistSidebarOpen" @click="closeWaitlistSidebar" />
    <Drawer
      ref="waitlistSidebarRef"
      class="w-full sm:w-[600px] p-8 pb-4 flex flex-col bg-gray-50!"
      :is-open="isWaitlistSidebarOpen"
      @click:close="closeWaitlistSidebar"
    >
      <template #header>
        <h3
          v-if="isWaitlistSidebarOpen"
          class="md:text-xl text-base font-semibold sticky w-full top-0"
        >
          {{
            t(
              `subscribeToEventUpdatesModal.${
                subscribed ? 'secondStep' : 'firstStep'
              }.title`
            )
          }}
        </h3>
      </template>

      <LazyEventSubscribeToUpdatesBody
        v-if="isWaitlistSidebarOpen"
        v-model:subscribed="subscribed"
      />
    </Drawer>
  </div>
</template>

<script setup lang="ts">

const { t } = useI18n()

// Owned here so the header and the "subscribed" step survive closing the drawer.
const subscribed = ref(false)

const waitlistSidebarRef = ref(null)

const { toggleWaitlistSidebar, closeWaitlistSidebar, isWaitlistSidebarOpen } =
  useUiState()

defineExpose({ toggleWaitlistSidebar })
</script>
<style>
body.prevent-scroll {
  overflow: hidden;
}
</style>
